// @ts-nocheck
import React from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { URLS } from "./_config";
import requireNoAuth from "./_common/hoc/reqNoAuth";
import requireAuth from "./_common/hoc/reqAuth";
import reqLayout from "./_common/hoc/layout";
import withLazyLoad from "./containers/lazyLoad";
import CacheBuster from "./CacheBuster";
import { ChatModalProvider } from "./context/ChatModalContext";

const Page404 = withLazyLoad(() => import("./containers/page-404"));
const Register = withLazyLoad(() => import("./containers/auth/register"));
const CompleteProfile = withLazyLoad(() => import("./containers/auth/complete-profile"));
const LoginWithEmailContainer = withLazyLoad(() => import("./containers/auth/loginWithEmail/login"));
const ForgotPassword = withLazyLoad(() => import("./containers/auth/forgot-password"));
const ResetPassword = withLazyLoad(() => import("./containers/auth/reset-password"));
const MyProfile = withLazyLoad(() => import("./containers/auth/myProfile"));
const ViewProfilePage = withLazyLoad(() => import("./containers/auth/view-profile"));
const EditProfilePage = withLazyLoad(() => import("./containers/auth/edit-profile"));
const CmsContainer = withLazyLoad(() => import("./containers/cms"));
const PricingPage = withLazyLoad(() => import("./containers/pricing/PricingPage"));
// const LandingPageContainer = withLazyLoad(() => import("./containers/landingInfo/landing"));
const Dashboard = withLazyLoad(() => import("./containers/dashboard"));
const NewJobPostingPage = withLazyLoad(() => import("./containers/job-posting/NewJobPostingPage"));
const JobPostingThankYouPage = withLazyLoad(() => import("./containers/job-posting/JobPostingThankYouContainer"));
const JobDetailsPage = withLazyLoad(() => import("./containers/job-details"));
const AICandidateSearchPage = withLazyLoad(() => import("./containers/ai-candidate-search/AICandidateSearchPage"));
const MemberListContainer = withLazyLoad(() => import("./containers/members/MemberListContainer"));
const AddMemberContainer = withLazyLoad(() => import("./containers/members/AddMemberContainer"));
const EditMemberContainer = withLazyLoad(() => import("./containers/members/EditMemberContainer"));
// const TalentScoutingContainer = withLazyLoad(()=>import("./containers/talent-scouting/TalentScoutingContainer"));
const VerifyEmail = withLazyLoad(() => import("./containers/auth/verify-email"));
const ComingSoonMain = withLazyLoad(() => import("./containers/coming-soon/ComingSoonMain"));
const AvalibilityPage = withLazyLoad(() => import("./containers/interview/avalibility"));
const SecurityContainer = withLazyLoad(() => import("./containers/settings/SecurityContainer"));
const SubscriptionsContainer = withLazyLoad(() => import("./containers/settings/SubscriptionsContainer"));
const PaymentSuccessContainer = withLazyLoad(() => import("./containers/settings/PaymentSuccessContainer"));
const PaymentCancelContainer = withLazyLoad(() => import("./containers/settings/PaymentCancelContainer"));
const BillingContainer = withLazyLoad(() => import("./containers/settings/BillingContainer"));
const HistoryContainer = withLazyLoad(() => import("./containers/settings/HistoryContainer"));
const Reports = withLazyLoad(() => import("./containers/reports/Reports"));
const VideoCV = withLazyLoad(() => import("./containers/video-cv/VideoCV"));
const Candidates = withLazyLoad(() => import("./containers/candidates/Candidates"));
const CandidateAdvancedSearch = withLazyLoad(
  () => import("./containers/candidate-advanced-search/CandidateAdvancedSearch"),
);
const OfferResponsePage = withLazyLoad(() => import("./containers/offer-response/offer-response"));
const InterviewResponseMain = withLazyLoad(() => import("./components/interview-response/InterviewResponseMain"));
const InterviewVideoPage = withLazyLoad(() => import("./containers/interview-video/interview-video"));
const InstantMeetPage = withLazyLoad(() => import("./containers/instant-meet/instant-meet"));
const ContactUsContainer = withLazyLoad(() => import("./containers/contact-us/ContactUsContainer"));
const NotificationsContainer = withLazyLoad(() => import("./containers/notifications/NotificationsContainer"));
const JobListingsContainer = withLazyLoad(() => import("./containers/job-listings/JobListingsContainer"));
const AutoLogin = withLazyLoad(() => import("./containers/autologin/AutoLogin"));
const MessagesContainer = withLazyLoad(() => import("./containers/messages/MessagesContainer"));
const InterviewsContainer = withLazyLoad(() => import("./containers/interviews"));
const HiresContainer = withLazyLoad(() => import("./containers/hires"));

function App() {
  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }
        return (
          <React.Fragment>
            <Router>
              <ChatModalProvider>
                <Switch>
                  <Route exact path={URLS.AUTH.LOGIN} component={requireNoAuth(LoginWithEmailContainer)} />
                  <Route exact path={URLS.AUTH.AUTO_LOGIN_TOKEN} component={AutoLogin} />
                  <Route exact path={URLS.AUTH.AUTO_LOGIN()} component={AutoLogin} />
                  <Route exact path={URLS.AUTH.REGISTRATION} component={requireNoAuth(Register)} />
                  <Route exact path={URLS.AUTH.COMPLETE_PROFILE} component={requireNoAuth(CompleteProfile)} />
                  <Route exact path={URLS.AUTH.FORGOT_PASSWORD} component={requireNoAuth(ForgotPassword)} />
                  <Route exact path={URLS.AUTH.RESET_PASSWORD} component={requireNoAuth(ResetPassword)} />
                  <Route exact path={URLS.AUTH.VERIFY_EMAIL} component={reqLayout(VerifyEmail)} />
                  <Route exact path={URLS.AUTH.MY_PROFILE} component={requireAuth(MyProfile)} />
                  <Route exact path={URLS.AUTH.VIEW_PROFILE} component={requireAuth(ViewProfilePage)} />
                  <Route exact path={URLS.AUTH.EDIT_PROFILE} component={requireAuth(EditProfilePage)} />
                  <Route exact path={URLS.DASHBOARD.MAIN} component={requireAuth(Dashboard)} />
                  <Route exact path={URLS.JOB_POSTING.EDIT()} component={requireAuth(NewJobPostingPage)} />
                  <Route exact path={URLS.JOB_POSTING.NEW} component={requireAuth(NewJobPostingPage)} />
                  <Route exact path={URLS.JOB_POSTING.AI_DESCRIPTION} component={requireAuth(NewJobPostingPage)} />
                  <Route exact path={URLS.JOB_POSTING.THANK_YOU()} component={requireAuth(JobPostingThankYouPage)} />
                  <Route exact path={URLS.JOB_POSTING.JOB_DETAILS} component={requireAuth(JobDetailsPage)} />
                  <Route exact path={URLS.JOB_POSTING.OFFER_RESPONSE} component={requireNoAuth(OfferResponsePage)} />
                  <Route
                    exact
                    path={URLS.JOB_POSTING.INTERVIEW_RESPONSE}
                    component={requireNoAuth(() => (
                      <InterviewResponseMain />
                    ))}
                  />
                  <Route exact path={URLS.INTERVIEW.AVALIBILITY} component={requireAuth(AvalibilityPage)} />
                  <Route exact path={URLS.INTERVIEW.VIDEO_CALL()} component={reqLayout(InterviewVideoPage)} />
                  <Route exact path={URLS.INSTANT_MEET.VIDEO_CALL()} component={reqLayout(InstantMeetPage)} />
                  {/* <Route exact path={URLS.JOB_POSTING.TALENT_SCOUTING} component={requireAuth(TalentScoutingContainer)} /> */}
                  <Route
                    exact
                    path={URLS.JOB_POSTING.AI_CANDIDATE_SEARCH}
                    component={requireAuth(AICandidateSearchPage)}
                  />
                  <Route
                    exact
                    path={URLS.JOB_POSTING.AI_CANDIDATE_SEARCH_EDIT()}
                    component={requireAuth(AICandidateSearchPage)}
                  />
                  <Route exact path={URLS.MEMBERS.LIST} component={requireAuth(MemberListContainer)} />
                  <Route exact path={URLS.MEMBERS.ADD} component={requireAuth(AddMemberContainer)} />
                  <Route exact path={URLS.MEMBERS.EDIT()} component={requireAuth(EditMemberContainer)} />
                  <Route exact path={URLS.SETTINGS.PAYMENT_SUCCESS} component={requireAuth(PaymentSuccessContainer)} />
                  <Route exact path={URLS.SETTINGS.PAYMENT_CANCEL} component={requireAuth(PaymentCancelContainer)} />
                  <Route exact path={URLS.SETTINGS.SECURITY} component={requireAuth(SecurityContainer)} />
                  <Route exact path={URLS.SETTINGS.SUBSCRIPTIONS} component={requireAuth(SubscriptionsContainer)} />
                  <Route exact path={URLS.SETTINGS.BILLING} component={requireAuth(BillingContainer)} />
                  <Route exact path={URLS.SETTINGS.HISTORY} component={requireAuth(HistoryContainer)} />
                  <Route exact path={URLS.REPORTS.MAIN} component={requireAuth(Reports)} />
                  <Route exact path={URLS.VIDEO_CV.MAIN} component={requireAuth(VideoCV)} />
                  <Route exact path={URLS.CANDIDATES.MAIN} component={requireAuth(Candidates)} />
                  <Route
                    exact
                    path={URLS.CANDIDATE_ADVANCED_SEARCH.MAIN}
                    component={requireAuth(CandidateAdvancedSearch)}
                  />
                  <Route exact path={URLS.JOB_POSTING.JOB_LISTINGS} component={requireAuth(JobListingsContainer)} />
                  <Route exact path={URLS.NOTIFICATIONS.MAIN} component={requireAuth(NotificationsContainer)} />
                  {/* Redirect /messages to candidate-advanced-search with message tab */}
                  <Route
                    exact
                    path={URLS.MESSAGES.MAIN}
                    render={({ location }) => {
                      const params = new URLSearchParams(location.search);
                      const conversationId = params.get("conversation_id");
                      const redirectUrl = conversationId
                        ? `${URLS.CANDIDATE_ADVANCED_SEARCH.MAIN}?tab=message&conversation_id=${conversationId}`
                        : `${URLS.CANDIDATE_ADVANCED_SEARCH.MAIN}?tab=message`;
                      return <Redirect to={redirectUrl} />;
                    }}
                  />
                  <Route exact path={URLS.INTERVIEWS.MAIN} component={requireAuth(InterviewsContainer)} />
                  <Route exact path={URLS.HIRES.MAIN} component={requireAuth(HiresContainer)} />
                  <Route exact path={URLS.SUPPORT.CONTACT_US} component={requireAuth(ContactUsContainer)} />
                  <Route path="/coming-soon" component={requireAuth(ComingSoonMain)} />

                  {/* <Route exact path={URLS.JOB_POSTING.AI_DESCRIPTION} component={requireAuth(AIJobDescriptionPage)} /> */}
                  <Route exact path="/pricing" component={PricingPage} />
                  <Route exact path={URLS.CMS.CMS} component={reqLayout(CmsContainer)} />
                  <Route path="*" component={reqLayout(Page404)} />
                </Switch>
              </ChatModalProvider>
            </Router>
          </React.Fragment>
        );
      }}
    </CacheBuster>
  );
}

export default App;
